import * as React               from 'react';
import * as PropTypes           from 'prop-types';
import * as cx                  from 'classnames';
import icons                    from '../../icons';
import LoadingAnimation         from '../../components/LoadingAnimation';
import { MessageTemplateProps } from './MessageTemplateTypes';
import { ViewContextTypes }     from '../MessageTemplatesList/MessageTemplatesListTypes';
import EditableField            from '../EditableField';

const MessageTemplateButton = props => (
    <div
        className={cx(
            'messageTemplate__button',
            'messageTemplate__' + props.label,
            'messageTemplate__button-' + props.colour,
            {'messageTemplate__button-disabled': props.disabled}
        )}
        onClick={props.onClickAction}
    >
        {props.label}
    </div>
);

const CancelButton = props => (
    <div
        className="messageTemplate__cancel"
        onClick={props.handleCancel}
    >
        {props.sendInProgress ? null : icons.cancel()}
    </div>
);

const createTemplateMessage = (messageTemplate, customFields, selectCF, handleEdit, selectedField, selectedTemplate) => {
    const templateArray = messageTemplate.template.message.split(/\{\{\s*|\s*\}\}/);
    const editedArray = templateArray.map((item, index) => {
        // Determine if there is a custom field corresponding to the current key
        const currentField = customFields.customFields[item];
        // If there is, return an editable field, otherwise return the text
        return (currentField) ? (
            <span
                key={index}
                className={cx(
                    'messageTemplate__editableField',
                    {'messageTemplate__editableField-selected': customFields.selectedField === item}
                )}
            >
                <EditableField
                    currentField={currentField}
                    messageTemplate={messageTemplate}
                    handleEdit={handleEdit}
                    selectedField={selectedField}
                    currentIndex={index}
                    fieldName={item}
                    selectCF={selectCF}
                    selectedTemplate={selectedTemplate}
                />
            </span>
        ) : item;
    });

    return editedArray;
};

// TODO: figure out where the x button went for message template view
const MessageTemplateComponent: React.StatelessComponent<MessageTemplateProps> = ({ messageTemplate, customFields, handleEdit, selectCF, activeMessageTemplate, sendInProgress, handleCancel, incrementEditField, decrementEditField, handleSend, viewContext, handleSelectTemplate }, { translate }) => {
    const indexOfSelectedField = messageTemplate.template.fields.map(field => field.name).indexOf(customFields.selectedField);
    const isInputTemplate = viewContext === ViewContextTypes.MESSAGES_INPUT;
    const showCancelButton = (isInputTemplate && (!indexOfSelectedField || indexOfSelectedField <= 0));
    const actionButtons = (activeMessageTemplate === messageTemplate.id) ?
        <div className={cx('messageTemplates__actionButtons', { [`messageTemplates__actionButtons--${viewContext}`]: Boolean(viewContext) })}>
            {
                // If we haven't started editing, show the cancel button. Otherwise, show the previous button.
                showCancelButton ?
                <MessageTemplateButton
                    label={translate('cancel')}
                    colour="transparent"
                    onClickAction={handleCancel}
                /> :
                <MessageTemplateButton
                    label={customFields.selectedField ? translate('previous') : translate('edit')}
                    colour={isInputTemplate ? 'transparent' : 'blue'}
                    onClickAction={customFields.selectedField ? decrementEditField : incrementEditField}
                />
            }
            { // If we haven't started editing or we've edited all the available fields, show the send button. Otherwise, show 'Next'
                customFields.selectedField === (messageTemplate.template.fields.length && messageTemplate.template.fields[messageTemplate.template.fields.length - 1].name)  || !customFields.selectedField ?
                    <MessageTemplateButton
                        label={translate('send')}
                        colour={viewContext !== ViewContextTypes.MESSAGES_INPUT ? 'pink' : 'red'}
                        disabled={!customFields.allowSend || sendInProgress}
                        onClickAction={customFields.allowSend && !sendInProgress ? handleSend : null}
                    /> :
                    <MessageTemplateButton
                        label={translate('next')}
                        onClickAction={incrementEditField}
                        colour={viewContext !== ViewContextTypes.MESSAGES_INPUT ? 'pink' : 'red'}
                    />
            }
        </div> :
        null;

    return (
        <div
            className={cx(
                'messageTemplate',
                messageTemplate.name,
                { [`messageTemplate--${viewContext}`]: Boolean(viewContext) },
                {'messageTemplate-active': activeMessageTemplate && (activeMessageTemplate === messageTemplate.id)},
                {'messageTemplate-inactive': activeMessageTemplate && (activeMessageTemplate !== messageTemplate.id)},
                {'messageTemplate-sending': sendInProgress}
            )}
            onClick={(event) => handleSelectTemplate(event)(messageTemplate.id)}
        >
            <div className="messageTemplate__bottomWrapper">
                {activeMessageTemplate && viewContext !== ViewContextTypes.MESSAGES_INPUT ? <CancelButton handleCancel={handleCancel} sendInProgress={sendInProgress} /> : null}
                {sendInProgress ? <LoadingAnimation/> : null}
                <div className="messageTemplate__bodyContainer">
                    {
                        activeMessageTemplate && viewContext === ViewContextTypes.MESSAGES_INPUT &&
                        <div className="messageTemplate__instructions">{translate('edit_template_details')}</div>
                    }
                    <div className="messageTemplate__body">
                        <div className="messageTemplate__message">
                            {createTemplateMessage(messageTemplate, customFields, selectCF, handleEdit, customFields.selectedField, customFields.selectedTemplate)}
                        </div>
                    </div>
                </div>
                {actionButtons}
            </div>
        </div>
    );
};

export default MessageTemplateComponent;

MessageTemplateComponent.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/MessageTemplate/MessageTemplateComponent.tsx